/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadAssignment } from './LeadAssignment';
import {
    LeadAssignmentFromJSON,
    LeadAssignmentFromJSONTyped,
    LeadAssignmentToJSON,
} from './LeadAssignment';

/**
 * 
 * @export
 * @interface CreateLeadAssignment200Response
 */
export interface CreateLeadAssignment200Response {
    /**
     * 
     * @type {LeadAssignment}
     * @memberof CreateLeadAssignment200Response
     */
    data: LeadAssignment;
}

/**
 * Check if a given object implements the CreateLeadAssignment200Response interface.
 */
export function instanceOfCreateLeadAssignment200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function CreateLeadAssignment200ResponseFromJSON(json: any): CreateLeadAssignment200Response {
    return CreateLeadAssignment200ResponseFromJSONTyped(json, false);
}

export function CreateLeadAssignment200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadAssignment200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': LeadAssignmentFromJSON(json['data']),
    };
}

export function CreateLeadAssignment200ResponseToJSON(value?: CreateLeadAssignment200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': LeadAssignmentToJSON(value.data),
    };
}

